import BreadCrumbs from "../../components/ui/BreadCrumbs";
import AddEditSalaryComponentForm from "../../components/sections/companySettings/salaryStructure/AddEditSalaryComponentForm";
import useAddEditSalaryComponent from "../../hooks/companySettings/salaryStructure/useAddEditSalaryComponent";

const breadcrumbs = [
  {
    label: "Company Settings",
    link: "/company-settings",
  },
  {
    label: "Salary Structure",
    link: "/company-settings/salary-structure",
  },
  {
    label: "Add Salary Component",
    link: "",
  },
];

const AddSalaryComponent = () => {
  const {
    control,
    watch,
    handleSubmit,
    addComponent,
    isAdding, // Derived options
    derivedOptions,
    hasMore,
    fetchNextDerivedOptions,
    setValue,
  } = useAddEditSalaryComponent();

  return (
    <div className="px-5">
      <BreadCrumbs crumbs={breadcrumbs} />

      <div className="flex justify-between items-center mb-6 mt-6">
        <h1 className=" text-xl font-bold ">New Earning</h1>
      </div>

      <AddEditSalaryComponentForm
        isEdit={false}
        control={control}
        watch={watch}
        handleSubmit={handleSubmit}
        addComponent={addComponent}
        setValue={setValue}
        isAdding={isAdding}
        derivedOptions={derivedOptions}
        hasMore={hasMore}
        fetchNextDerivedOptions={fetchNextDerivedOptions}
      />
    </div>
  );
};

export default AddSalaryComponent;
